import Masonry from "@mui/lab/Masonry";
import React from "react";

export default React.memo(Masonry);
